import {RouteConfig} from 'vue-router';
import CatalogueItems from './pages/CatalogueItems.vue';

export default [
    
] as RouteConfig[];
